import React from 'react'

interface ShowLessIconProps {
    width: string,
    height: string,
    fill: string
}

interface CloseIconProps {
    width: string,
    height: string,
    fill: string
}

export const ShowLessIcon: React.FunctionComponent<ShowLessIconProps> = ({
  width,
  height,
  fill
}) => {
  return (
        <svg width={width} height={height} viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M18.0002 9.00024C18.0002 8.74424 17.9023 8.48824 17.7073 8.29324L9.70725 0.293239C9.31625 -0.0977612 8.68425 -0.0977612 8.29325 0.293239L0.29325 8.29324C-0.09775 8.68424 -0.09775 9.31624 0.29325 9.70724C0.68425 10.0982 1.31625 10.0982 1.70725 9.70724L9.00025 2.41424L16.2932 9.70724C16.6842 10.0982 17.3162 10.0982 17.7073 9.70724C17.9023 9.51224 18.0002 9.25624 18.0002 9.00024Z" fill={fill} />
        </svg>
  )
}

export const ShowMoreIcon: React.FunctionComponent<ShowLessIconProps> = ({
  width,
  height,
  fill
}) => {
  return (
        <svg width={width} height={height} viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M-6.43966e-06 0.599913C-6.44638e-06 0.753519 0.076216 0.907124 0.227884 1.02413L6.45013 5.82429C6.75424 6.0589 7.2458 6.0589 7.54991 5.82429L13.7722 1.02413C14.0763 0.78952 14.0763 0.410308 13.7722 0.1757C13.468 -0.0589075 12.9765 -0.0589076 12.6724 0.1757L7.00002 4.55165L1.32767 0.1757C1.02355 -0.0589081 0.531996 -0.0589081 0.227884 0.1757C0.076216 0.292703 -6.43295e-06 0.446308 -6.43966e-06 0.599913Z" fill={fill} />
        </svg>
  )
}

export const CloseIcon: React.FunctionComponent<CloseIconProps> = ({
  width,
  height,
  fill
}) => {
  return (
        <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8334 1.34163L10.6584 0.166626L6.00008 4.82496L1.34175 0.166626L0.166748 1.34163L4.82508 5.99996L0.166748 10.6583L1.34175 11.8333L6.00008 7.17496L10.6584 11.8333L11.8334 10.6583L7.17508 5.99996L11.8334 1.34163Z"
                fill={fill} fillOpacity="0.54" />
        </svg>
  )
}
